import type { OktaAuth } from '@okta/okta-auth-js';
import { postFetch } from './post-fetch';
import { HttpError } from './request';

/**
 * POST that survives a stale cached token. A 401 usually means the token in
 * sessionStorage went stale, so renew once and retry; if renewal fails, fall
 * back to full re-authentication. Any other error propagates untouched.
 */
export const postFetchWithRenewal = async <T>(
	oktaAuth: OktaAuth,
	token: string | null | undefined,
	url: string,
	body: Record<string, unknown>
): Promise<T> => {
	try {
		return await postFetch<T>(token, url, body);
	} catch (error) {
		if (error instanceof HttpError && error.status === 401) {
			const renewedToken = await oktaAuth.getOrRenewAccessToken().catch(() => null);

			if (renewedToken) {
				return await postFetch<T>(renewedToken, url, body);
			}

			await oktaAuth.signInWithRedirect();
		}

		throw error;
	}
};
